import { render } from "./PanelRelatedItems.vue?vue&type=template&id=641f4bbc&scoped=true&ts=true"
import script from "./PanelRelatedItems.vue?vue&type=script&lang=ts"
export * from "./PanelRelatedItems.vue?vue&type=script&lang=ts"

import "./PanelRelatedItems.vue?vue&type=style&index=0&id=641f4bbc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641f4bbc"]])

export default __exports__